"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const rect_1 = require("./rect");
const inViewInfo_1 = require("./inViewInfo");
const _ = require("underscore");
let InViewDirective = class InViewDirective {
    constructor(el) {
        this.el = el;
        this._initialCall = true;
        this._lastInfo = null;
        this.onInView = new core_1.EventEmitter();
        this.inViewId = "";
        this.options = {};
    }
    ngOnInit() {
        if (!this.options) {
            this.options = {};
        }
        if (this.options.hasOwnProperty('offset')) {
            this.options.offset = this.normalizeOffset(this.options.offset);
        }
        else {
            this.options.offset = [0, 0, 0, 0];
        }
        if (this.options.hasOwnProperty('viewportOffset')) {
            this.options.viewportOffset = this.normalizeOffset(this.options.viewportOffset);
        }
        else {
            this.options.viewportOffset = [0, 0, 0, 0];
        }
        if (!this.options.hasOwnProperty('generateDirection')) {
            this.options.generateDirection = false;
        }
        console.log(this.options);
    }
    ngDoCheck() {
        this.onCheckInView();
    }
    onCheckInView() {
        let newInfo = this.calcInfo();
        if (this._lastInfo) {
            // Add inview direction info
            if (newInfo.inView && this._lastInfo.elementRect && this.options.generateDirection) {
                newInfo.directionHorizontal = newInfo.elementRect.left - this._lastInfo.elementRect.left;
                newInfo.directionVertical = newInfo.elementRect.top - this._lastInfo.elementRect.top;
            }
            // Calculate changed flag
            newInfo.changed = newInfo.inView !== this._lastInfo.inView;
        }
        if ((this._initialCall && newInfo.inView) || newInfo.changed ||
            newInfo.directionVertical !== this._lastInfo.directionVertical ||
            newInfo.directionHorizontal !== this._lastInfo.directionHorizontal) {
            // Execute in-view callback
            this.onInView.emit(newInfo);
            this._lastInfo = newInfo;
            this._initialCall = false;
        }
    }
    calcInfo() {
        let info = new inViewInfo_1.InViewInfo();
        info.id = this.inViewId;
        info.viewportRect = this.getViewportRect().offsetRect(this.options.viewportOffset);
        info.elementRect = this.getBoundingClientRect().offsetRect(this.options.offset);
        let isVisible = !!(this.el.nativeElement.offsetWidth || this.el.nativeElement.offsetHeight || this.el.nativeElement.getClientRects().length);
        info.inView = isVisible && info.elementRect.intersectRect(info.viewportRect);
        info.element = this.el;
        return info;
    }
    normalizeOffset(offset) {
        if (!_.isArray(offset)) {
            return [offset, offset, offset, offset];
        }
        if (offset.length == 2) {
            return offset.concat(offset);
        }
        else if (offset.length == 3) {
            return offset.concat([offset[1]]);
        }
        return offset;
    }
    getViewportRect() {
        if (window.innerHeight) {
            return new rect_1.Rect(0, 0, window.innerWidth, window.innerHeight);
        }
        var mode = document.compatMode;
        if (mode === 'CSS1Compat') {
            return new rect_1.Rect(0, 0, document.documentElement.clientWidth, document.documentElement.clientHeight);
        }
        return new rect_1.Rect(0, 0, document.body.clientWidth, document.body.clientHeight);
    }
    getBoundingClientRect() {
        let boundingNativeElRect = this.el.nativeElement.getBoundingClientRect();
        return new rect_1.Rect(boundingNativeElRect.left, boundingNativeElRect.top, boundingNativeElRect.width, boundingNativeElRect.height);
    }
};
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], InViewDirective.prototype, "onInView", void 0);
__decorate([
    core_1.Input('inaxInView'),
    __metadata("design:type", String)
], InViewDirective.prototype, "inViewId", void 0);
__decorate([
    core_1.Input('inaxInViewOptions'),
    __metadata("design:type", Object)
], InViewDirective.prototype, "options", void 0);
InViewDirective = __decorate([
    core_1.Directive({
        selector: '[inaxInView]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], InViewDirective);
exports.InViewDirective = InViewDirective;
